import React, { useState } from 'react';
import { FileCopyOutlined as Icon } from '@mui/icons-material';

import ChargerTaskCreatingDialog
  from '../../../../screens/ChargerDetails/components/ChargerTaskCreatingDialog';

import { toEditing } from '../../ChargerTaskForm';

import { ActionWrap } from './style';

function RetryTaskAction(props) {
  const { task } = props;
  const [state, setState] = useState(false);

  const open = () => setState(true);
  const close = () => setState(false);

  return (
    <>
      {
        state && (
          <ChargerTaskCreatingDialog
            chargerId={task.chargerUuid}
            defaultState={toEditing(task, { note: '' })}
            isOpen
            close={close}
          />
        )
      }
      <ActionWrap className="link" onClick={open}>
        <Icon />
        {' '}
        Copy
      </ActionWrap>
    </>
  );
}

export default RetryTaskAction;
